export default {
  develop: window.location.href.indexOf('localhost') !== -1,
  apiURL: process.env.API_ENDPOINT,
  cfURL: process.env.CF_ENDPOINT,
  ecURL: process.env.EC_ENDPOINT,
  cookieDomain: process.env.COOKIE_DOMAIN,
  allowRedirectDomains: process.env.ALLOW_REDIRECT_DOMAINS,
  companyId: process.env.COMPANY_ID,
  requestToken: 'a@4ta2QkzfgCx-1YWd28HiyEXrStSq6@',
  googleApiKey: process.env.GOOGLEAPI_KEY
}



// WEBPACK FOOTER //
// ./src/setting.js